import React from 'react'
import DownloadCsvPdfSplitButton from './DownloadCsvPdfSplitButton'
import { UI_COLOR_PRIMARY, UI_COLOR_PRIMARY_ALT_HOVER } from '../../constants/uiColors'
import { getCurrentDate } from '../../helpers/formatDate'
import { downloadCsvRows } from '../../helpers/downloadCsvRows'
import { buildCsvFile } from '../../settlements/helpers/csvBuilder'
import { buildSettlementPdf } from '../../settlements/helpers/pdfBuilder'

export default function DownloadSettlementButton({
  data,
  canSeeAnnulledDocumentsTab,
  canWrite = false
}) {
  const [isGeneratingPdf, setIsGeneratingPdf] = React.useState(false)
  const origin = window.location.origin
  const filename = `DetallesDeLiquidacion_${data?.user_full_name}_${data?.business_uid}_${getCurrentDate()}.csv`

  const handleCsvDownload = () => {
    downloadCsvRows(buildCsvFile(data, canSeeAnnulledDocumentsTab, origin), filename)
  }

  const handlePdfDownload = async () => {
    setIsGeneratingPdf(true)

    try {
      await buildSettlementPdf(data, canSeeAnnulledDocumentsTab, origin, { canWrite })
    } catch (error) {
      console.error('Error al generar PDF de liquidación:', error)
    } finally {
      setIsGeneratingPdf(false)
    }
  }

  return (
    <DownloadCsvPdfSplitButton
      label={isGeneratingPdf ? 'Descargando...' : undefined}
      pdfLabel={isGeneratingPdf ? 'Descargando...' : undefined}
      color={UI_COLOR_PRIMARY}
      hoverColor={UI_COLOR_PRIMARY_ALT_HOVER}
      onExportCsv={handleCsvDownload}
      onExportPdf={handlePdfDownload}
      disabled={isGeneratingPdf}
    />
  )
}
